import { API_ENDPOINT } from '../constants';
import { HTTP } from '../services/http.service';
export const RolesService = {
  getModuleRoles: (data: { profile: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}roles/permissions`, data);
  },
  getRoles: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}roles`);
  },
  saveRoles: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}roles`, data);
  },
  editRoles: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}roles`, data);
  },
  getRolesForAccount: (data: { accountId: string }) => {
    const { accountId } = data;
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}roles/${accountId}`);
  },
  duplicateRoles: (data: { role: string; account: string }) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}roles/duplicate`, data);
  },
  changeStatus: (data: any, type: string) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}roles/${type}`, data);
  },
  getAccountRoles: (account_id: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}roles/${account_id}`);
  }
};
